var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#0866FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6611 4.00333L13.5024 4C11.0772 4 9.5099 5.54552 9.5099 7.93762V9.75313H7.33943C7.15188 9.75313 7 9.89927 7 10.0795V12.71C7 12.8903 7.15205 13.0363 7.33943 13.0363H9.5099V19.6738C9.5099 19.854 9.66178 20 9.84933 20H12.6812C12.8687 20 13.0206 19.8539 13.0206 19.6738V13.0363H15.5584C15.7459 13.0363 15.8978 12.8903 15.8978 12.71L15.8989 10.0795C15.8989 9.99299 15.863 9.91009 15.7995 9.84884C15.7359 9.78758 15.6493 9.75313 15.5593 9.75313H13.0206V8.2141C13.0206 7.47438 13.204 7.09886 14.2065 7.09886L15.6607 7.09836C15.8481 7.09836 16 6.95222 16 6.77211V4.32958C16 4.14964 15.8483 4.00366 15.6611 4.00333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.bafec8a87026d58bd79d82dd3134cd96.svg";
export { ForwardRef as ReactComponent };